import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxLoadingModule } from 'ngx-loading';
import { ImportExportFormsModule } from '../../../parc-management/import-export-forms/import-export-forms.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PlanificationMissionComponent } from './planification-mission.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { DayTranslatePipeModule } from 'src/app/pipes/dayTranslate.module';

//import { DndModule } from 'ng2-dnd';

@NgModule({
  declarations: [
    PlanificationMissionComponent,
  ],
  imports: [
    CommonModule,
    NgxLoadingModule.forRoot({}),
    ImportExportFormsModule,
    BsDatepickerModule.forRoot(),
    ModalModule,
    FormsModule, // Required for ngModel
    NgSelectModule,
    DayTranslatePipeModule

  ],
  exports: [
    PlanificationMissionComponent,
  ],
  providers: [
  ],
})
export class PlanificationMissionFormModule { }
